import { createContext, createElement, useContext } from 'react';
export const CustomPageProxiesClientContext = createContext(null);
export const CustomPageSubjectContext = createContext(null);
export const CustomPageModeContext = createContext(null);
const noopCustomPageDispatchAction = () => { };
export const CustomPageDispatchActionContext = createContext(noopCustomPageDispatchAction);
export function CustomPageRendererContextProvider({ value, children, }) {
    return createElement(CustomPageDispatchActionContext.Provider, { value: value.dispatchAction }, createElement(CustomPageProxiesClientContext.Provider, { value: value.proxiesClient }, createElement(CustomPageSubjectContext.Provider, { value: value.subject }, createElement(CustomPageModeContext.Provider, { value: value.mode }, children))));
}
export function useCustomPageProxiesClient() {
    const ctx = useContext(CustomPageProxiesClientContext);
    if (ctx === null) {
        throw new Error('useCustomPageProxiesClient must be used within a CustomPageRendererContextProvider');
    }
    return ctx;
}
export function useCustomPageSubject() {
    return useContext(CustomPageSubjectContext);
}
export function useCustomPageMode() {
    return useContext(CustomPageModeContext);
}
export function useCustomPageDispatchAction() {
    const ctx = useContext(CustomPageDispatchActionContext);
    return ctx;
}
